/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Helmet } from "react-helmet";
import { useAppMandantContext } from "../../../../Basis/Components/AppMandantContext";

export interface AppHelmetProps {
    children: React.ReactNode;
}

export default function AppHelmet({ children }: AppHelmetProps) {
    const mandant = useAppMandantContext().mandant;
    return (
        <>
            <Helmet>
                {<title>{`${!!mandant ? `${mandant.bezeichnung} - ` : ""}LANcloud`}</title>}
            </Helmet>
            {children}
        </>
    );
}